var styleDataHash = "9a78d39d";
const injectCss = (() => {
  var css = `.KFdpI{height:18px;position:relative;width:18px}.WEvPy,._-4Kbf{height:100%;left:0;position:absolute;top:0;width:100%;fill:none;stroke-linecap:round}.WEvPy{animation:QzSND 666ms linear infinite;opacity:.3}.WEvPy,._-4Kbf{stroke:currentColor}._-4Kbf{animation:QzSND 2s linear infinite}@keyframes QzSND{to{transform:rotate(1turn)}}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});
injectCss();
var double_loader_default = {
  "wrapper": "KFdpI",
  "top": "WEvPy",
  "bottom": "_-4Kbf",
  "rotation": "QzSND"
};
export {
  double_loader_default as default,
  injectCss
};
//# sourceMappingURL=double-loader-scss.js.map
